module.exports = __webpack_public_path__ + "img/vuforia.4f462667.png";